import $ from 'jquery';

const selectElement = $('.js_select');

selectElement.on('change', function(event) {
    const selectedOption = event.target.value;

    selectElement.prop('value', '#default');

    $('html, body').animate(
        {
            scrollTop: $(selectedOption).offset().top - 150
        },
        500
    );
});
